import { getStatusColor } from "./helper";

// Function to add samples series

export function getGenericSamplesSeries(name, samplesData, color) {
    return {
        name: name,
        data: samplesData,
        type: 'line',
        smooth: true,
        lineStyle: {
            type: 'solid',
            color: color,
            width: 1
        },
        itemStyle: {
            color: function (params) {
                return getStatusColor(params.data.status);
            }
        },
        symbol: 'circle',
        symbolSize: 7,
    };
}

export function getSamplesSeries(samplesData) {
    return getGenericSamplesSeries('Objective Samples', samplesData, '#007aff');
}

// Function to add objectives series

export function hexToRgba(hex, alpha) {
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
    }
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function getGenericObjectivesSeries(name, objectiveData, color) {
    return {
        name: name,
        data: objectiveData,
        isObjective: true,
        type: 'line',
        lineStyle: {
            type: 'dotted',
            color: hexToRgba(color, 0.35)
        },
        itemStyle: {
            color: hexToRgba(color, 0.5)
        },
        symbol: 'diamond',
        symbolSize: 10,
    };
}

export function getObjectivesSeries(objective, objectiveType) {
    const series = [];
    if (objectiveType === 'Regular') {
        series.push(getGenericObjectivesSeries('Quantitative Objective', [
            [objective.startDate, objective.startQuantitativeValue],
            [objective.endDate, objective.endQuantitativeValue]
        ], '#3233c1'));
    } else if (objectiveType === 'Threshold_Above' || objectiveType === 'Threshold_Below') {
        series.push(
            getGenericObjectivesSeries('Quantitative Objective Threshold', [
                [objective.startDate, objective.startQuantitativeValue],
                [objective.endDate, objective.startQuantitativeValue]
            ], '#3233c1'));
    } else if (objectiveType === 'Range') {
        series.push(
            getGenericObjectivesSeries('Quantitative Objective Lower Range', [
                [objective.startDate, objective.startQuantitativeValue],
                [objective.endDate, objective.startQuantitativeValue]
            ], '#3233c1'));
        series.push(
            getGenericObjectivesSeries('Quantitative Objective Upper Range', [
                [objective.startDate, objective.endQuantitativeValue],
                [objective.endDate, objective.endQuantitativeValue]
            ], '#3233c1'));
    }
    return series;
}

// Function to add missed date series
export function getMissedDateSeries(missedDateSample, minValue, maxValue) {
    if (missedDateSample) {
        return [{
            name: 'Missed Date',
            data: [
                { value: [missedDateSample, minValue], label: { show: true, formatter: 'Missed Date' } },
                { value: [missedDateSample, maxValue] }
            ],
            type: 'line',
            lineStyle: {
                type: 'dotted',
                color: 'rgba(255, 0, 0, 0.466)'
            },
            itemStyle: {
                color: 'red'
            }
        }];
    } else {
        return [{
            name: 'Missed Date', // Add empty series to avoid bug in ECharts
            data: [
                { value: ['1900-01-01', minValue], label: { show: true, formatter: 'Missed Date' } },
            ],
            type: 'line',
        }];
    }
}

// Function to add current date series
export function getCurrentDateSeries(isCurrentDateInRange, currentDate, yAxis) {
    let minValue, maxValue;

    if (yAxis.type === 'category') {
        minValue = 0;
        maxValue = yAxis.data.length - 1;
    } else {
        minValue = yAxis.min;
        maxValue = yAxis.max;
    }

    if (isCurrentDateInRange) {
        return [{
            name: 'Current Date',
            isCurrentDate: true,
            data: [
                { value: [currentDate, minValue], label: { show: true, formatter: 'Today' } },
                { value: [currentDate, maxValue] }
            ],
            type: 'line',
            lineStyle: {
                type: 'dotted',
                color: 'lightgray'
            },
            itemStyle: {
                color: 'darkgray'
            }
        }];
    } else {
        return [];
    }
}